import styled from 'styled-components';
import { Button } from '@m/alchemy-ui/Button';

import styleTheme from 'common/constants/styleTheme';

export const Item = styled.a`
  font-size: 14px;
`;

export const NewQaReviewButton = styled(Button)`
  color: ${styleTheme.colors.white} !important;
  &:hover {
    color: ${styleTheme.colors.white};
  }
`;
